import { render, staticRenderFns } from "./tableAllCargos.vue?vue&type=template&id=3243038c&"
import script from "./tableAllCargos.vue?vue&type=script&lang=js&"
export * from "./tableAllCargos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports